import { Col } from '../../Grid';
import unlinkAccount from '../unlinkAccount';

const RenderMerchant = ({ partnerPointsName, partnerData, memberId }) => {
  const { id, merchantLogoUrl, isDelinkingDisable } = partnerData;

  return (
    <Col className="exchange-points">
      <img src={merchantLogoUrl} alt="merchantLogoUrl" />
      <h4>
        {/* No balance: the partner's own figure is not returned after a conversion, so
            anything shown here would be our own arithmetic rather than the partner's. */}
        <span>{partnerPointsName}</span>
        <div className="exchange-member-id">Member ID: {memberId}</div>
        {!isDelinkingDisable && (
          <button
            type="button"
            role="link"
            className="exchange-unlink"
            data-testid="unlink-account"
            onClick={unlinkAccount(id)}
          >
            Unlink account
          </button>
        )}
      </h4>
    </Col>
  );
};

export default RenderMerchant;
